import React from 'react';

const Footer = () => {
  return (
    <footer style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      gap: '20px',
      padding: '20px',
      marginTop: '40px',
      borderTop: '1px solid #ddd'
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '20px' }}>
        {/* Instagram */}
        <a
          href="https://www.instagram.com/brightonicebergers/"
          target="_blank"
          rel="noopener noreferrer"
          title="Instagram"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
            <circle cx="17.5" cy="6.5" r="1.5"></circle>
          </svg>
        </a>

        {/* Facebook */}
        <a
          href="https://www.facebook.com/brighton.iceberger"
          target="_blank"
          rel="noopener noreferrer"
          title="Facebook"
          style={{ display: 'flex', alignItems: 'center' }}
        >
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M18 2h-3a6 6 0 0 0-6 6v3H7v4h2v8h4v-8h3l1-4h-4V8a2 2 0 0 1 2-2h3z"></path>
          </svg>
        </a>
      </div>

      <p style={{ margin: 0, fontSize: '14px', color: '#555' }}>
        Site built by{' '}
        <a href="https://yarratech.com" target="_blank" rel="noopener noreferrer">
          yarratech.com
        </a>
      </p>
    </footer>
  );
};

export default Footer;
